(function () {
  angular.module('kareo.ui.shared.directives.billing-workflow.scroll-to-selected', [])
  .directive('dropDownGroup',
    () => {
      return {
        restrict: 'AC',
        link: dropDownContainerLink,
        controller: dropDownContainerController
      };
    })
  .directive('listItemToScroll',
    () => {
      return {
        restrict: 'AC',
        link: scrollToSelectedLink,
        require: '^dropDownGroup'
      };
    });

  function scrollToSelectedLink(scope, element, attrs, ctrl) {
    var parentContainer = element[0].parentElement;
    var listElement = element[0];
    scope.$watch(() => {
      return ctrl.isDropDownActivated;
    }, (value) => {
      if (value === true) {
        if (parentContainer && attrs.listItemToScroll === 'true') {
          if (listElement.offsetTop + 20 < parentContainer.offsetHeight) {
            parentContainer.scrollTop = 0;
          } else {
            parentContainer.scrollTop = listElement.offsetTop;
          }
        }
      }
    });
  }

  function dropDownContainerLink(scope, element, attrs, ctrl) {
    var activeClass = attrs.dropDownActiveClass;
    scope.$watch(() => {
      return element.hasClass(activeClass);
    }, (value) => {
      if (value) {
        ctrl.isDropDownActivated = true;
      } else {
        ctrl.isDropDownActivated = false;
      }
    });
  }

  function dropDownContainerController() {
    this.isDropDownActivated = false;
  }
})();
